"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaProperties = exports.AgentSchemaProperties = exports.AgentSchema = exports.AgentConfigurationSchema = exports.AgentStatus = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const workflow_schema_1 = require("./workflow-schema");
var AgentStatus;
(function (AgentStatus) {
    AgentStatus["Enabled"] = "enabled";
    AgentStatus["Disabled"] = "disabled";
})(AgentStatus || (exports.AgentStatus = AgentStatus = {}));
exports.AgentConfigurationSchema = workflow_schema_1.WorkflowConfigurationSchema.extend({
    defaultSchedule: zod_1.z.string(),
    relatedWorkflows: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
    })),
    stripeProductId: zod_1.z.string(),
    stripePriceIds: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        trialPeriodDays: zod_1.z.number().optional(),
    })),
    maxQuantity: zod_1.z.number(),
});
exports.AgentSchema = base_schema_1.BaseSchema.extend({
    agentId: zod_1.z.string(),
    status: zod_1.z.nativeEnum(AgentStatus),
    quantity: zod_1.z.number(),
    stripeSubscriptionId: zod_1.z.string(),
    scheduleIds: zod_1.z.array(zod_1.z.string()),
    optInSettings: zod_1.z.record(zod_1.z.boolean()).optional(),
    createdBy: zod_1.z.string(),
    updatedBy: zod_1.z.string(),
});
exports.AgentSchemaProperties = {
    collectionName: "agents",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
// For backward compatibility
exports.schemaProperties = exports.AgentSchemaProperties;
//# sourceMappingURL=agent-schema.js.map